import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-sm text-center">
        <p className="text-sm font-medium text-orange-600">404</p>
        <h1 className="mt-2 text-2xl font-semibold text-foreground">页面不存在</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          这个页面可能已经被移动或删除。
        </p>
        <Link
          to="/"
          className="mt-5 inline-flex h-10 items-center rounded-md bg-orange-500 px-4 text-sm font-medium text-white hover:bg-orange-600"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
